import { createReducer, on } from '@ngrx/store';
import { selectPaymentFraction, setPaymentFractions, setPaymentFractionState } from './paymentFractions.actions';
import { IPaymentFractionState } from './paymentFractions.models';

export const initialState: IPaymentFractionState = { selected: null, list: [] };

export const paymentFractionsReducers = createReducer(
    initialState,
    on(setPaymentFractionState, (state, { new_state }) => { return { ...state, ...new_state }}),
    on(setPaymentFractions, (state, { paymentFractions }) => { return { ...state, list: paymentFractions }}),
    on(selectPaymentFraction, (state, { paymentFractionSelected }) => { return { ...state, selected: paymentFractionSelected }}),
);
